import { Button } from '@/atoms/Button'
import { CaptionSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export const GeoBlockedButton = () => {
  const { t } = useTranslate('watch')
  return (
    <Button className="w-[220px]" disabled outline variant="white">
      <CaptionSM weight="bold" className="text-center" color="black">
        {t('unavailableInLocation', 'This video is not currently available in your location')}
      </CaptionSM>
    </Button>
  )
}
